import { useEffect, useState } from 'react';

import type { ILoanChartFilter } from 'entities/chartFilters';

import type { IDropdownOption } from '../../../RatesChart.types';

export const useFiltersData = (filtersData?: ILoanChartFilter[]) => {
  const [types, setTypes] = useState<IDropdownOption[]>([]);
  const [sums, setSums] = useState<IDropdownOption[]>([]);
  const [terms, setTerms] = useState<IDropdownOption[]>([]);

  const [selectedType, setSelectedType] = useState<IDropdownOption | null>(null);
  const [selectedSum, setSelectedSum] = useState<IDropdownOption | null>(null);
  const [selectedTerm, setSelectedTerm] = useState<IDropdownOption | null>(null);

  const recalculate = (
    newSelectedType: IDropdownOption | null,
    newSelectedSum: IDropdownOption | null,
    newSelectedTerm: IDropdownOption | null,
  ) => {
    if (filtersData && filtersData.length > 0) {
      const extractedTypes = filtersData.map((filter) => ({
        label: filter.label,
        value: filter.value,
      }));

      setTypes(extractedTypes);

      const newType = newSelectedType || extractedTypes[0];
      setSelectedType(newType);

      const selectedTypeData = filtersData.find((filter) => filter.value === newType.value);
      if (selectedTypeData) {
        const extractedSums = selectedTypeData.amounts.map((amount) => ({
          label: amount.label,
          value: amount.value,
        }));

        setSums(extractedSums);

        const newSum = newSelectedSum || extractedSums[0];
        setSelectedSum(newSum);

        const selectedSumData = selectedTypeData.amounts.find((amount) => amount.value === newSum.value);
        if (selectedSumData) {
          const extractedTerms = selectedSumData.terms.map((term) => ({
            label: term.label,
            value: term.value,
          }));

          setTerms(extractedTerms);

          const newTerm = newSelectedTerm || extractedTerms[0];
          setSelectedTerm(newTerm);
        }
      }
    }
  };

  useEffect(() => {
    recalculate(selectedType, selectedSum, selectedTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersData]);

  return { types, sums, terms, selectedType, selectedSum, selectedTerm, recalculate };
};
